module.exports = __webpack_public_path__ + "img/Dr Phil-sample.6a1e1617.gif";